import XLRLogger from 'src/common/helpers/logger';
import { store } from 'src/common/redux/configure-store';
import { TenderExchangeActions } from 'src/common/redux/reducers/tender-exchange-reducer';
import { getAllTenderExchanges } from './services/get-all-tender-exchanges';

export const getTenderExchangeConfig = async (): Promise<void> => {
  return getAllTenderExchanges()
    .then(tenderExchanges => {
      store.dispatch(TenderExchangeActions.setTenderExchange(tenderExchanges));
    })
    .catch(err => {
      XLRLogger.error({
        message: err,
        source: 'get-tender-exchanges.ts',
      });
    });
};
